export default __webpack_public_path__ + "images/sd-090d0e106e0c7fd28b239852af2c91e1.svg";